import Tooltip from "@mui/material/Tooltip"
import type { FC } from "react"
import React, { useEffect, useRef, useState } from "react"

import { classNames } from "@/utils/utils"

interface Props {
  text: string
  className?: string
  placement?: "top" | "bottom" | "left" | "right"
}

export const TruncatedText: FC<Props> = ({ text, className = "", placement = "top" }) => {
  const textRef = useRef<HTMLSpanElement>(null)
  const [isOverflowing, setIsOverflowing] = useState(false)

  useEffect(() => {
    const element = textRef.current
    if (element) {
      setIsOverflowing(element.scrollWidth > element.clientWidth)
    }
  }, [text])

  return (
    <Tooltip title={isOverflowing ? text : null} placement={placement}>
      <span ref={textRef} className={classNames("block truncate", className)}>
        {text}
      </span>
    </Tooltip>
  )
}
